<div class="trd-gauge-container">
  <mat-progress-spinner class="trd-gauge-text-shadow" [diameter]="50" [value]="100" mode="determinate" strokeWidth="4"
    [appSpinnerColor]="color">
  </mat-progress-spinner>
  <mat-progress-spinner [diameter]="50" [value]="percents" mode="determinate" [appSpinnerColor]="color">
  </mat-progress-spinner>
  <div class="trd-gauge-text">
    {{(percents/100) | percent:'1.0-2'}}
  </div>
</div>